import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';

import { OPEN_DOWN } from 'react-dates/src/constants';

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Row, Col, ButtonGroup, Button, Collapse, Alert } from 'reactstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { DateRangePicker } from 'react-dates';

import { connect } from 'react-redux';
import {
    tours_getHistory,
    tours_getTypeahead,
    tours_onHistoryClear,
    tours_onHistoryCurrentPage,
    tours_getFilteredHistory,
} from 'redux/actions/tours';

import {
    faFilter,
    faSync,
    faSearch,
    faChevronDown,
    faChevronUp,
    faPrint
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
library.add(faPrint);
library.add(faFilter);
library.add(faSync);
library.add(faSearch);
library.add(faChevronDown);
library.add(faChevronUp);

class HistoryHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filterIcon: 'chevron-down',
            filterCollapse: false,
            isAlert: false,
            focusedInput: null
        }

        this.start = null;
        this.end = null;

        this.refStaffId = null;
        this.refName = null;
        this.refDevice = null;
        this.refZone = null;
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(tours_getTypeahead());
    }

    onDatesChange = ({ startDate, endDate }) => {
        this.start = startDate;
        this.end = endDate;
    }
    onFilterSubmit = () => {
        const { dispatch, logHistory } = this.props;

        let filter = { ...this.props.filter };
        if (this.start) {
            filter.start = this.start.hour(0);
            filter.start = this.start.minute(0);
            filter.start = this.start.second(0);
            filter.start = this.start.format('YYYY-MM-DD HH:mm:ss');
        }
        if (this.end) {
            filter.end = this.end.hour(23);
            filter.end = this.end.minute(59);
            filter.end = this.end.second(59);
            filter.end = this.end.format('YYYY-MM-DD HH:mm:ss');
        }

        const { staffId, name, device, zone, start, end } = filter;
        if (staffId || name || device || zone || start || end) {
            this.props.setFilter(filter, true);
        } else {
            this.props.setFilter(filter, false);
            return;
        }

        dispatch(tours_onHistoryClear());
        dispatch(tours_getFilteredHistory(0, logHistory.itemPerPage, filter));
    }
    onFilterCleared = () => {
        const { dispatch, logHistory } = this.props;

        if (this.refStaffId) { this.refStaffId.getInstance().clear(); }
        if (this.refName) { this.refName.getInstance().clear(); }
        if (this.refDevice !== null) { this.refDevice.getInstance().clear(); }
        if (this.refZone !== null) { this.refZone.getInstance().clear(); }

        let filter = {
            staffId: null,
            name: null,
            device: null,
            zone: null,
            start: null,
            end: null
        }
        this.start = null;
        this.end = null;
        //this.isFilterActive = false;
        this.props.setFilter(filter, false);

        dispatch(tours_onHistoryClear());
        dispatch(tours_onHistoryCurrentPage(1));
        dispatch(tours_getHistory(0, logHistory.itemPerPage));
    }
    onPrintPage = () => {
        const { logHistory, history } = this.props;
        const { list, byid } = logHistory;

        let pZone = '';
        for (let i = 0; i < list.length; i++) {
            const key = list[i];
            if (key === -1) {
                continue;
            }
            const item = byid[key];
            if (pZone === '') {
                pZone = item.zone;
                continue;
            }
            if (pZone !== item.zone) {
                this.setState({ isAlert: true });
                return;
            }
        }

        history.push({
            pathname: '/touring/history/historyprint'
        });
    }
    onChevronUp = () => {
        this.setState({ filterIcon: 'chevron-up' });
    }
    onChevronDown = () => {
        this.setState({ filterIcon: 'chevron-down' });
    }
    onToggleCollapse = () => {
        this.setState({
            filterCollapse: !this.state.filterCollapse
        });
    }
    onToggleAlert = () => {
        this.setState({ isAlert: false });
    }

    render() {
        const { typeahead } = this.props;
        const { filterCollapse, filterIcon, isAlert } = this.state;

        let { name, staffId, device, zone } = typeahead;
        device = device.filter(dev => {
            return dev.callerId !== null && dev.callerId !== '';
        });

        return <React.Fragment>
            <Row className='w-100 ml-0'>
                {/*Header Title*/}
                <Col xs='12' sm='5' md='4' lg='5' xl='7' className='my-auto pl-0 text-left h3 font-weight-normal'>
                    Touring / <strong>History</strong>
                </Col>
                {/*Date Picker*/}
                <Col xs='4' sm='3' md='4' lg='4' xl='3' className='text-center px-0 my-sm-auto my-2'>
                    <DateRangePicker
                        small={true}
                        minimumNights={0}
                        openDirection={OPEN_DOWN}
                        isOutsideRange={() => false}
                        startDate={this.start}
                        startDateId='startDateFilter_id'
                        endDate={this.end}
                        endDateId='endDateFilter_id'
                        focusedInput={this.state.focusedInput}
                        onFocusChange={focusedInput => this.setState({ focusedInput })}
                        onDatesChange={this.onDatesChange} />
                </Col>
                {/*Filter Control*/}
                <Col xs='8' sm='4' md='4' lg='3' xl='2' className='my-auto text-right px-1'>
                    <ButtonGroup size='md'>
                        <Button color='primary' onClick={this.onFilterSubmit}>
                            <FontAwesomeIcon icon='search' size='1x' />
                        </Button>{' '}
                        <Button color='secondary' onClick={this.onFilterCleared}>
                            <FontAwesomeIcon icon='sync' size='1x' />
                        </Button>{' '}
                        <Button color='dark' className='filter-toggler' onClick={this.onToggleCollapse}>
                            Filter{' '}
                            <FontAwesomeIcon icon={filterIcon} size='1x' />
                        </Button>{' '}
                        <Button size='sm' onClick={this.onPrintPage} color='light'>
                            <FontAwesomeIcon icon='print' />
                        </Button>
                    </ButtonGroup>
                </Col>
            </Row>
            <Collapse isOpen={filterCollapse} onEntered={this.onChevronUp} onExited={this.onChevronDown}>
                <Row className='justify-content-center'>
                    {/**Marshal's Name */}
                    <Col xs='12' sm='6' lg='3' xl='3' className='mt-3 mb-1'>
                        <Typeahead
                            ref={t => { this.refName = t; }}
                            bsSize='small'
                            id='name'
                            labelKey='name'
                            options={name}
                            maxHeight='50'
                            placeholder="Marshal's Name"
                            onInputChange={o => {
                                let filter = { ...this.props.filter };
                                filter.name = o;
                                this.props.setFilter(filter)
                            }}
                            onChange={o => {
                                if (o.length > 0) {
                                    let filter = { ...this.props.filter };
                                    filter.name = o[0].name;
                                    this.props.setFilter(filter)
                                }
                            }} />
                    </Col>
                    {/**Staff No */}
                    <Col xs='12' sm='6' lg='3' xl='3' className='mt-3'>
                        <Typeahead
                            ref={t => { this.refStaffId = t; }}
                            bsSize='small'
                            id='staffId'
                            labelKey='staffId'
                            options={staffId}
                            maxHeight='50'
                            placeholder='Staff No'
                            onInputChange={o => {
                                let filter = { ...this.props.filter };
                                filter.staffId = o;
                                this.props.setFilter(filter);
                            }}
                            onChange={o => {
                                if (o.length > 0) {
                                    let filter = { ...this.props.filter };
                                    filter.staffId = o[0].staffId;
                                    this.props.setFilter(filter);
                                }
                            }}
                        />
                    </Col>
                    {/**Device */}
                    <Col xs='12' sm='6' lg='3' xl='3' className='mt-3 mb-1'>
                        <Typeahead
                            ref={t => { this.refDevice = t; }}
                            bsSize='small'
                            id='callerId'
                            labelKey='callerId'
                            options={device}
                            minLength={2}
                            maxHeight='50'
                            placeholder='Device'
                            onInputChange={o => {
                                let filter = { ...this.props.filter };
                                filter.device = o;
                                this.props.setFilter(filter);
                            }}
                            onChange={o => {
                                if (o.length > 0) {
                                    let filter = { ...this.props.filter };
                                    filter.device = o[0].callerId;
                                    this.props.setFilter(filter);
                                }
                            }}
                        />
                    </Col>
                    {/**Zone */}
                    <Col xs='12' sm='6' lg='3' xl='3' className='mt-3 mb-1'>
                        <Typeahead
                            ref={t => { this.refZone = t; }}
                            bsSize='small'
                            id='section'
                            labelKey='section'
                            options={zone}
                            maxHeight='50'
                            placeholder='Zone'
                            onInputChange={o => {
                                let filter = { ...this.props.filter };
                                filter.zone = o;
                                this.props.setFilter(filter);
                            }}
                            onChange={o => {
                                let filter = { ...this.props.filter };
                                filter.zone = o[0].section;
                                this.props.setFilter(filter);
                            }}
                        />
                    </Col>
                </Row>
            </Collapse>
            <Alert style={{ marginTop: '10px' }} className='text-center' color='danger' isOpen={isAlert} toggle={this.onToggleAlert}>
                Only ONE zone is allowed to be printed at a time!
            </Alert>
        </React.Fragment>

    }
}

const mapStateToProps = store => {
    return {
        dispatch: store.dispatch,
        logHistory: store.tours.history,
        histlog: store.tours.log,
        typeahead: store.tours.typeahead
    };
};

HistoryHeader.propTypes = {
    dispatch: PropTypes.func,
    typeahead: PropTypes.object,
    logHistory: PropTypes.object,
    history: PropTypes.object,
    setFilter: PropTypes.func,
    filter: PropTypes.object
};

export default connect(mapStateToProps)(HistoryHeader);



// WEBPACK FOOTER //
// ./src/components/blocks/HistoryHeader/HistoryHeader.js